import {copyPasteLocaleResources} from './bundles/copy-paste'
import {feedbackLocaleResources} from './bundles/feedback'
import {studioDefaultLocaleResources} from './bundles/studio'
import {validationLocaleResources} from './bundles/validation'
import {defineLocale} from './helpers'

/**
 * The default US English locale for the studio.
 *
 * @internal
 * @hidden
 */
export const usEnglishLocale = defineLocale({
  id: 'en-US',
  title: 'English (US)',
  bundles: [
    studioDefaultLocaleResources,
    validationLocaleResources,
    copyPasteLocaleResources,
    feedbackLocaleResources,
  ],

  weekInfo: {
    firstDay: 7, // Sunday
    weekend: [6, 7], // Saturday, Sunday
  },
})

/**
 * The default locale for the studio.
 *
 * @internal
 * @hidden
 */
/** @alias */
export const defaultLocale = usEnglishLocale
